var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIm23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 289,
    viewBox: "0 0 220 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.754,
    cy: 134.3,
    rx: 108.254,
    ry: 132.8,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.908 209.69C209.908 216.162 204.684 221.386 198.212 221.386C191.739 221.386 186.516 216.162 186.516 209.69C186.516 203.217 191.739 197.994 198.212 197.994C204.684 197.994 209.908 203.217 209.908 209.69Z",
    fill: "url(#paint0_radial_281_1643)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1265 208.52C32.1265 214.992 26.903 220.216 20.4304 220.216C13.9578 220.216 8.73438 214.992 8.73438 208.52C8.73438 202.047 13.9578 196.824 20.4304 196.824C26.903 196.824 32.1265 202.047 32.1265 208.52Z",
    fill: "url(#paint1_radial_281_1643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.641 288.5C124.481 288.5 135.7 277.244 135.7 263.358C135.7 249.473 124.481 238.216 110.641 238.216C96.8014 238.216 85.582 249.473 85.582 263.358C85.582 277.244 96.8014 288.5 110.641 288.5Z",
    fill: "url(#paint2_radial_281_1643)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.855 235.493C190.855 241.763 185.796 246.822 179.526 246.822C173.257 246.822 168.197 241.763 168.197 235.493C168.197 229.224 173.257 224.165 179.526 224.165C185.796 224.165 190.855 229.224 190.855 235.493Z",
    fill: "url(#paint3_radial_281_1643)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.277 235.493C51.277 241.763 46.2175 246.822 39.9481 246.822C33.6787 246.822 28.6191 241.763 28.6191 235.493C28.6191 229.224 33.6787 224.165 39.9481 224.165C46.2175 224.165 51.277 229.224 51.277 235.493Z",
    fill: "url(#paint4_radial_281_1643)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0909 183.374C18.0909 188.228 14.1733 192.146 9.31891 192.146C4.46449 192.146 0.546875 188.228 0.546875 183.374C0.546875 178.519 4.46449 174.602 9.31891 174.602C14.1733 174.602 18.0909 178.519 18.0909 183.374Z",
    fill: "url(#paint5_radial_281_1643)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9217 255.849C79.9217 263.217 73.9951 269.164 66.6513 269.164C59.3074 269.164 53.3809 263.217 53.3809 255.849C53.3809 248.481 59.3074 242.535 66.6513 242.535C73.9951 242.535 79.9217 248.481 79.9217 255.849Z",
    fill: "url(#paint6_radial_281_1643)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.441 255.849C167.441 263.217 161.515 269.164 154.171 269.164C146.827 269.164 140.9 263.217 140.9 255.849C140.9 248.481 146.827 242.535 154.171 242.535C161.515 242.535 167.441 248.481 167.441 255.849Z",
    fill: "url(#paint7_radial_281_1643)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.263 183.374C219.263 188.228 215.345 192.146 210.491 192.146C205.636 192.146 201.719 188.228 201.719 183.374C201.719 178.519 205.636 174.602 210.491 174.602C215.345 174.602 219.263 178.519 219.263 183.374Z",
    fill: "url(#paint8_radial_281_1643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.212 209.69) rotate(90) scale(11.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F1F458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E74C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4304 208.52) rotate(90) scale(11.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F1F458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E74C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.641 263.358) rotate(90) scale(25.1418 25.0592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.548077,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.526 235.493) rotate(90) scale(11.3289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.274038,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9481 235.493) rotate(90) scale(11.3289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.274038,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.31891 183.374) rotate(90) scale(8.77203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.543269,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.6513 255.849) rotate(90) scale(13.3142 13.2704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427885,
    stopColor: "#F1F458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E74C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.171 255.849) rotate(90) scale(13.3142 13.2704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.403846,
    stopColor: "#F1F458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E74C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_281_1643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.491 183.374) rotate(90) scale(8.77203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.543269,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm23);
export default __webpack_public_path__ + "static/media/im23.5c9a0e231caf6bc738b22a01c67b9526.svg";
export { ForwardRef as ReactComponent };